import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '@core/services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-password-reset',
  templateUrl: './password-reset.component.html',
  styleUrl: './password-reset.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PasswordResetComponent {
  private fb = inject(FormBuilder);
  private authService = inject(AuthService);
  private router = inject(Router);

  form: FormGroup;
  type: 'login' | 'signup' | 'reset' = 'reset';
  loading = false;
  serverMessage: any | undefined;
  successMessage: string | undefined;

  constructor() {
    this.form = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }

  get email() {
    return this.form.get('email');
  }

  async onSubmit() {
    if (this.form.invalid) {
      return;
    }

    this.loading = true;
    this.serverMessage = undefined;
    this.successMessage = undefined;

    try {
      const email = this.form.get('email')?.value;
      await this.authService.sendPasswordResetEmail(email);

      this.successMessage =
        'Password reset email sent successfully! Please check your inbox.';

      // Optionally redirect to login after a delay
      setTimeout(() => {
        this.router.navigate(['/login']);
      }, 3000);
    } catch (error: any) {
      console.error('Password reset error:', error);
      this.serverMessage = this.getErrorMessage(error);
    } finally {
      this.loading = false;
    }
  }

  private getErrorMessage(error: any): string {
    if (error?.code) {
      switch (error.code) {
        case 'auth/user-not-found':
          return 'No account found with this email address.';
        case 'auth/invalid-email':
          return 'Please enter a valid email address.';
        case 'auth/too-many-requests':
          return 'Too many requests. Please try again later.';
        default:
          return (
            error.message || 'An error occurred while sending the reset email.'
          );
      }
    }
    return 'An error occurred while sending the reset email.';
  }
}
